'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _currencies = require('../../../common/utils/currencies');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentHistoryDirective = function () {
  function PaymentHistoryDirective() {
    _classCallCheck(this, PaymentHistoryDirective);

    this.getPaymentCurrencyDescription = function (feisCurrencyCode) {
      return (0, _currencies.getCurrencyDescription)(feisCurrencyCode);
    };

    this.getLongCurrencyForHistory = function (feisCurrencyCode) {
      return (0, _currencies.getLongCurrency)(feisCurrencyCode);
    };

    this.showAll = false;
    this.shortlistedNum = 2;

    if (this.payments) {
      this.total = this.getTotal(this.payments);
    }
  }

  _createClass(PaymentHistoryDirective, [{
    key: 'getTotal',
    value: function getTotal(payments) {
      return payments.map(function (d) {
        return d.amt;
      }).reduce(function (prev, curr) {
        return prev + curr;
      }, 0);
    }
  }, {
    key: 'shortlistedMessage',
    value: function shortlistedMessage() {
      return !this.showAll ? 'You are seeing ' + this.shortlistedNum + ' of ' + this.payments.length + ' payments' : 'You are seeing all ' + this.payments.length + ' payments';
    }
  }]);

  return PaymentHistoryDirective;
}();

exports.default = angular.module('ifeis.dashboard-payment-history', []).directive('fPaymentHistory', function () {
  return {
    bindToController: true,
    controller: 'PaymentHistoryDirective',
    controllerAs: 'payments',
    replace: true,
    scope: {
      payments: '='
    },
    template: require('./tpl.html')
  };
}).controller('PaymentHistoryDirective', PaymentHistoryDirective);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/payment-history/index.js
// module id = 526
// module chunks = 0